import HTTP from './http'
import { AxiosResponse } from 'axios'
import { EServiceOrigin } from 'utils/catalogsApi/constants'
import { getToken } from 'utils/auth'
import { API_HEADER_CONTENT_TYPE as HEADER, REQUEST_RETRIES_DOUBLE } from './constants'
import { IHTTPVerbsData, IOpenAmountData } from './interface'

// ENTITIES API KEYS GET ·······························································································
export const entitiesApiKeysGet = ({ id, token }: IHTTPVerbsData) =>
  HTTP.panel.get(`/v1/entities/${id}/api-keys`, {
    headers: {
      ...HEADER.activityPermission.getFromValue('api_keys:read'),
      ...HEADER.auth.bearer(token),
      ...HEADER.entityId.getFromValue(id),
      ...HEADER.json
    }
  })

// PANEL ENTITIES BY ID GET ······························································································
export const entitiesByIdGet = ({ id, token }: IHTTPVerbsData) =>
  HTTP.panel.get(`/v2/entities/${id}`, {
    'axios-retry': {
      retries: REQUEST_RETRIES_DOUBLE
    },
    headers: {
      ...HEADER.activityPermission.getFromValue('business_profile:read'),
      ...HEADER.auth.bearer(token),
      ...HEADER.entityId.getFromValue(id),
      ...HEADER.json
    },
    params: {
      env_mode: null
    }
  })

// ONBOARDING ENTITIES BY ID GET ······························································································
export const entitiesByIdOnboardingGet = ({ id, token }: IHTTPVerbsData) =>
  HTTP.onboarding.get(`/v1/entities/${id}`, {
    headers: {
      ...HEADER.activityPermission.getFromValue('business_profile:read'),
      ...HEADER.auth.bearer(token),
      ...HEADER.entityId.getFromValue(id),
      ...HEADER.json
    }
  })

// USER ENTITIES BY ID GET
export const entitiesUsersByIdGet = ({ id, token }: IHTTPVerbsData) =>
  HTTP.panel.get(`/v1/entities/${id}/users`, {
    headers: {
      ...HEADER.activityPermission.getFromValue('business_profile:read'),
      ...HEADER.auth.bearer(token),
      ...HEADER.entityId.getFromValue(id)
    }
  })

// ENTITIES BY ID PUT ·································································································
export const entitiesByIdPut = ({ data, id, token }: IHTTPVerbsData) => {
  return HTTP.onboarding.put(`/v1/entities/${id}/profile`, JSON.stringify(data), {
    headers: {
      ...HEADER.auth.bearer(token),
      ...HEADER.json
    }
  })
}

// ENTITIES BY ID PUT ·································································································
export const v2entitiesByIdPut = ({ data, id, token }: IHTTPVerbsData) => {
  return HTTP.onboarding.put(`/v2/entities/${id}/profile`, JSON.stringify(data), {
    headers: {
      ...HEADER.auth.bearer(token),
      ...HEADER.json
    }
  })
}

// ENTITIES CHANGE MCC GET ····························································································
export const entitiesChangeMccGet = ({ id, token }: IHTTPVerbsData) =>
  HTTP.panel.get(`/v1/entities/${id}/change-mcc`, {
    headers: {
      ...HEADER.activityPermission.getFromValue('business_profile:read'),
      ...HEADER.auth.bearer(token),
      ...HEADER.entityId.getFromValue(id)
    }
  })

// ENTITIES CHANGE MCC PUT ····························································································
export const entitiesChangeMccPut = ({ data, id, token }: IHTTPVerbsData) =>
  HTTP.panel.put(`/v1/entities/${id}/change-mcc`, JSON.stringify(data), {
    headers: {
      ...HEADER.activityPermission.getFromValue('business_profile:update'),
      ...HEADER.auth.bearer(token),
      ...HEADER.entityId.getFromValue(id),
      ...HEADER.json
    }
  })

// ENTITIES ENVIRONMENT MODE PUT ·······················································································
export const entitiesEnvironmentModePut = ({ data, entityId, userId }: IHTTPVerbsData) =>
  HTTP.panel.put(
    `/v1/resources-service/entities/${entityId}/entity-users/${userId}/environment-mode`,
    JSON.stringify(data),
    {
      headers: {
        ...HEADER.auth.bearer(getToken()),
        ...HEADER.entityId.getFromValue(entityId),
        ...HEADER.json
      }
    }
  )

// ENTITIES EVALUATION GET ·····························································································
export const entitiesEvaluationGet = ({ id, token }: IHTTPVerbsData) => {
  return HTTP.onboarding.get(`/v1/resources-service/entities/${id}/evaluation-results`, {
    headers: {
      ...HEADER.auth.bearer(token),
      ...HEADER.json
    }
  })
}
// Se podria eliminar?
// ENTITIES EVALUATION PUT ·····························································································
export const entitiesEvaluationPut = ({ activationId, id, token }: IHTTPVerbsData) =>
  HTTP.onboarding.put(`/v1/entities/${id}/activation/${activationId}`, null, {
    headers: {
      ...HEADER.auth.bearer(token)
    }
  })

// ENTITIES EVALUATION RISK RESULTS GET ···············································································
export const entitiesEvaluationRiskResultsGet = ({ id }: IHTTPVerbsData) =>
  HTTP.panel.get(`/v1/entities/${id}/evaluation-result-risk-reasons`, {
    headers: {
      ...HEADER.activityPermission.getFromValue('business_profile:read'),
      ...HEADER.auth.bearer(getToken()),
      ...HEADER.entityId.getFromValue(id)
    }
  })

// ENTITIES DOCUMENTS RESULTS GET ···············································································
export const entitiesDocumentsResultsGet = (entityId: string): Promise<AxiosResponse> =>
  HTTP.panel.get(`/v1/entities/${entityId}/documents`, {
    headers: {
      ...HEADER.activityPermission.getFromValue('business_profile:read'),
      ...HEADER.auth.bearer(getToken()),
      ...HEADER.entityId.getFromValue(entityId)
    }
  })

// ENTITIES EVALUATION RISK RESULTS PUT ···············································································
export const entitiesEvaluationRiskResultsPut = ({ id, token }: IHTTPVerbsData) =>
  HTTP.panel.put(`/v1/resources-service/entities/${id}/risk-evaluations`, null, {
    headers: {
      ...HEADER.auth.bearer(token)
    }
  })

// ENTITIES EVALUATION RISK ADMIN GET ··················································································
export const entitiesEvaluationRiskAdminGet = ({ id }: IHTTPVerbsData) => {
  return HTTP.panel.get(`/v1/risk-admin-bff/evaluations?entityId=${id}&pageSize=30`, {
    headers: {
      ...HEADER.auth.bearer(getToken()),
      ...HEADER.json
    }
  })
}

// ENTITIES FEE 3DS GET ···············································································
export const entitiesFee3DSGet = ({ id, token }: IHTTPVerbsData) =>
  HTTP.panel.get(`v1/entities/${id}/fee-three-ds`, {
    headers: {
      ...HEADER.activityPermission.getFromValue('3ds:read'),
      ...HEADER.auth.bearer(token),
      ...HEADER.entityId.getFromValue(id),
      ...HEADER.json
    }
  })

// ENTITY ID FROM COMPANY ID GET ······················································································
export const entitiesIdFromCompanyIdGet = ({ id, token, userId }: IHTTPVerbsData) =>
  HTTP.panel.get(
    // tslint:disable-next-line: max-line-length
    `/v1/resources-service/entities?id_reference_company=${id}&user_id=${userId}`,
    {
      headers: {
        ...HEADER.auth.bearer(token),
        ...HEADER.json,
        ...HEADER.serviceOrigin.getFromValue(EServiceOrigin.PAYMENT_LINK)
      }
    }
  )

// ENTITIES INVITATION USER DELETE ·····················································································
export const entitiesInvitationUserDelete = ({ id, testMode, userId }: IHTTPVerbsData) =>
  HTTP.panel.delete(`/v1/entities/${id}/invitation/user/${userId}`, {
    headers: {
      ...HEADER.activityPermission.getFromValue('users:delete'),
      ...HEADER.auth.bearer(getToken()),
      ...HEADER.entityId.getFromValue(id),
      ...HEADER.json,
      ...HEADER.liveMode.getFromTestMode(testMode)
    }
  })

// ENTITIES INVITATIONS USER GET ······················································································
export const entitiesInvitationUserGet = ({ id, token }: IHTTPVerbsData) =>
  HTTP.onboarding.get(`/v1/resources-service/invitations?entityId=${id}`, {
    headers: {
      ...HEADER.activityPermission.getFromValue('invitations:read'),
      ...HEADER.auth.bearer(token),
      ...HEADER.entityId.getFromValue(id)
    }
  })

// ENTITIES INVITATION USER POST ······················································································
export const entitiesInvitationUserPost = ({ data, id, testMode }: IHTTPVerbsData) =>
  HTTP.panel.post(`/v1/entities/${id}/invitation`, JSON.stringify(data), {
    headers: {
      ...HEADER.activityPermission.getFromValue('invitations:write'),
      ...HEADER.auth.bearer(getToken()),
      ...HEADER.entityId.getFromValue(id),
      ...HEADER.json,
      ...HEADER.liveMode.getFromTestMode(testMode)
    }
  })

// ENTITIES INVITATIONS USER PUT ······················································································
export const entitiesInvitationUserPut = ({ data, id, testMode, userId }: IHTTPVerbsData) =>
  HTTP.panel.put(`/v1/entities/${id}/invitation/user/${userId}`, JSON.stringify(data), {
    headers: {
      ...HEADER.activityPermission.getFromValue('users:update'),
      ...HEADER.auth.bearer(getToken()),
      ...HEADER.entityId.getFromValue(id),
      ...HEADER.json,
      ...HEADER.liveMode.getFromTestMode(testMode)
    }
  })

// ENTITY PAYMENT LINK GET ····························································································
export const entityPaymentLinkGet = ({ id, token }: IHTTPVerbsData) =>
  HTTP.panel.get(`v1/resources-service/entities/${id}/payment-link`, {
    headers: {
      ...HEADER.auth.bearer(token),
      ...HEADER.json
    }
  })

// ENTITIES PROCESSING SETTINGS 3DS GET ···············································································
export const entitiesProcessingSettings3DSGet = ({ id, token }: IHTTPVerbsData) =>
  HTTP.panel.get(`v1/resources-service/entities/${id}/processing-settings-3ds`, {
    headers: {
      ...HEADER.auth.bearer(token),
      ...HEADER.json
    }
  })

// ENTITIES PROCESSING SETTINGS 3DS PUT ···············································································
export const entitiesProcessingSettings3DSPut = ({ data, id, token }: IHTTPVerbsData): Promise<AxiosResponse> =>
  HTTP.panel.put(`v1/entities/${id}/processing-settings-3ds`, JSON.stringify(data), {
    headers: {
      ...HEADER.activityPermission.getFromValue('3ds:update'),
      ...HEADER.auth.bearer(token),
      ...HEADER.entityId.getFromValue(id),
      ...HEADER.json
    }
  })

// ENTITIES SEARCH GET ·································································································
export const entitiesSearchGet = ({ idReferenceCompany }: IHTTPVerbsData) =>
  HTTP.panel.get(`/v1/search-entities/${idReferenceCompany}`, {
    headers: {
      ...HEADER.auth.bearer(getToken()),
      ...HEADER.json
    }
  })

// ENTITIES STAGES ADD POST ···························································································
export const entitiesStagesAddPost = ({ data, id, token }: IHTTPVerbsData) =>
  HTTP.onboarding.post(`/v1/entities/${id}/stages`, JSON.stringify(data), {
    headers: {
      ...HEADER.auth.bearer(token),
      ...HEADER.json
    }
  })

// ENTITIES UPLOAD FILE POST ··························································································
export const entitiesUploadFilePost = ({
  data,
  fileClassification,
  fileTypeId,
  id,
  international,
  token
}: Required<
  Pick<IHTTPVerbsData, 'data' | 'fileClassification' | 'fileTypeId' | 'id' | 'international' | 'token'>
>): Promise<AxiosResponse> => {
  const FORM_DATA = new FormData()
  FORM_DATA.append('file', data)
  FORM_DATA.append('fileClassificationId', fileClassification || '')
  FORM_DATA.append('fileTypeId', fileTypeId || '')
  FORM_DATA.append('international', international || 'false')

  return HTTP.onboarding.post(`/v1/entity/${id}/upload-file`, FORM_DATA, {
    headers: {
      ...HEADER.auth.bearer(token),
      ...HEADER.multipartFormData
    }
  })
}

export const entitiesUploadFilePostV2 = ({
  data,
  evaluationId,
  fileClassification,
  fileTypeId,
  id,
  token
}: Required<
  Pick<IHTTPVerbsData, 'data' | 'evaluationId' | 'fileClassification' | 'fileTypeId' | 'id' | 'token'>
>): Promise<AxiosResponse> => {
  const FORM_DATA = new FormData()
  FORM_DATA.append('file', data)
  FORM_DATA.append('fileClassificationId', fileClassification || '')
  FORM_DATA.append('fileTypeId', fileTypeId || '')
  FORM_DATA.append('evaluationId', evaluationId || '')

  return HTTP.panel.post(`/v1/entities/${id}/upload-file`, FORM_DATA, {
    headers: {
      ...HEADER.auth.bearer(token),
      ...HEADER.multipartFormData
    }
  })
}

// ENTITIES USER AD OPS POST ···························································································
export const entitiesUserAdOpsPost = ({ id }: IHTTPVerbsData) =>
  HTTP.panel.post(`/v1/Entities/${id}/user-adops`, '', {
    headers: {
      ...HEADER.auth.bearer(getToken()),
      ...HEADER.json
    }
  })

// ENTITIES DELETE DRAFT ······················································································
export const entitiesDeleteDraft = ({ id }: IHTTPVerbsData) =>
  HTTP.panel.delete(`/v1/resources-service/entities/${id}`, {
    headers: {
      ...HEADER.auth.bearer(getToken()),
      ...HEADER.entityId.getFromValue(id)
    }
  })

// GET OPEN AMOUNT CONFIG BY ENTITY ····························································································
export const getOpenAmountConfigByEntity = ({ id, token }: IHTTPVerbsData) =>
  HTTP.panel.get(`v1/OpenLinkConfiguration?entityId=${id}`, {
    headers: {
      ...HEADER.auth.bearer(token),
      ...HEADER.json
    }
  })

// POST OPEN AMOUNT CONFIG BY ENTITY ····························································································
export const postOpenAmountConfigByEntity = ({ config, token }: IOpenAmountData) =>
  HTTP.panel.post(`v1/OpenLinkConfiguration`, config, {
    headers: {
      ...HEADER.auth.bearer(token),
      ...HEADER.json
    }
  })

// PUT OPEN AMOUNT CONFIG BY ENTITY ····························································································
export const putOpenAmountConfigByEntity = ({ config, token }: IOpenAmountData) =>
  HTTP.panel.put(`v1/OpenLinkConfiguration`, config, {
    headers: {
      ...HEADER.auth.bearer(token),
      ...HEADER.json
    }
  })

// POST SAVE FILE ·································································································
export const postSaveFile = ({ entityId }: IHTTPVerbsData): Promise<AxiosResponse> =>
  HTTP.onboarding.post(`/v2/entity/${entityId}/save-files`, undefined, {
    headers: {
      ...HEADER.auth.bearer(getToken()),
      ...HEADER.json
    }
  })

// POST SAVE  ·································································································
export const postSave = ({ data, entityId }: IHTTPVerbsData): Promise<AxiosResponse> =>
  HTTP.onboarding.post(`/v2/entity/${entityId}/save`, data, {
    headers: {
      ...HEADER.auth.bearer(getToken()),
      ...HEADER.json
    }
  })

// POST ENTITY CONFIRM ·································································································
export const entityConfirm = ({ id, token }: IHTTPVerbsData): Promise<AxiosResponse> =>
  HTTP.onboarding.post(`/v2/entities/${id}/confirm`, '', {
    headers: {
      ...HEADER.auth.bearer(token),
      ...HEADER.json
    }
  })

// ACCOUNT ID GET ·····························································································
export const accountIdGet = ({ id, token }: IHTTPVerbsData): Promise<AxiosResponse> =>
  HTTP.onboarding.get(`/v1/salesforce-service/account/${id}`, {
    headers: {
      ...HEADER.auth.bearer(token),
      ...HEADER.json
    }
  })
